<!-- NEWDESIGN DONE -->
<app-modal-skeletton
  [dialogRef]="dialogRef"
  [hasFooterButtons]="true"
  [disableClose]="modalData.forceUpdate"
  width="lg"
>
  <ng-container ngProjectAs="title">
    <ng-container i18n="@@updateVersion.modal_title"
      >Une nouvelle version est disponible !</ng-container
    >
  </ng-container>

  <ng-container ngProjectAs="content">
    <div class="center-content">
      <div
        class="w-full"
        [style.aspect-ratio]="'261 / 214'"
        [style.max-width]="'261px'"
        [style.max-height]="'214px'"
      >
        <img src="assets/assets-site/images/svg-illustrations/dashboard-go-premium.svg" />
      </div>
    </div>

    <div
      class="grid grid-cols-[auto_1fr] gap-4 items-start rounded-lg p-4 bg-v2-theme-blueBrand-100"
    >
      <div class="text-v2-primary">
        <app-icon icon="rocket" [width]="24" />
      </div>

      <div>
        <div class="text-xl font-bold ext-v2-primary mb-2"
          ><ng-container i18n="@@updateVersion.version_actuelle">Version actuelle</ng-container> :
          {{ environmentService.stringifiedFrontAppVersion }} /
          <ng-container i18n="@@updateVersion.nouvelle">Nouvelle</ng-container> :
          {{
            modalData.lastDeployedVersions
              ? modalData.lastDeployedVersions.lastVersion.name
              : '[auto]'
          }}</div
        >
        <div i18n="@@updateVersion.modal_content" class="prose prose-xs">
          <p>Pour te mettre à jour, clique sur le bouton ci-dessous ou actualise ta page.</p>
          <p
            >Si tu rencontres des problèmes, que le site ne se met pas correctement à jour ou que ce
            message continue à s'afficher :</p
          >
          <ul>
            <li
              >Vérifie que tu n'as pas d'autres onglets ouverts de
              {{ languageService.siteDomain }}</li
            >
            <li>Vide le cache de ton navigateur</li>
            <li
              >Si tout ceci ne fonctionne pas, contacte nous sur Intercom (pastille bleue en bas à
              droite)</li
            >
          </ul>
        </div>
      </div>

      @if (modalData.lastDeployedVersions?.lastVersion.content) {
      <div class="col-span-2 bg-v2-theme-white p-4 rounded-lg">
        <div i18n="@@updateVersion.contenu_de_la_nouvelle_version" class="font-bold mb-2"
          >Contenu de la mise à jour</div
        >
        <div
          [innerHTML]="modalData.lastDeployedVersions.lastVersion.content | safe : 'html'"
          class="prose"
        ></div>
      </div>
      }
    </div>
  </ng-container>

  <ng-container ngProjectAs="footer-buttons">
    <app-button i18n="@@updateVersion.mettre_a_jour" (click)="updateSite()">
      Mettre à jour !
    </app-button>
    @if (!modalData.forceUpdate) {
    <app-button i18n="@@utils.plus_tard" mat-dialog-close color="white/primary" [withBorder]="true"
      >Plus tard</app-button
    >
    }
  </ng-container>
</app-modal-skeletton>
